export default __webpack_public_path__ + "assets/arcgis-instant-apps-96.png";